import axios from 'axios'
import urlJoin from 'url-join'

const baseUrl = urlJoin(window.__API_URL, window.__API_PATH)

const apiInstance = axios.create({
  baseURL: baseUrl,
  timeout: 10000,
  withCredentials: true
})

apiInstance.interceptors.request.use(config => {
  config.headers['Cache-Control'] = 'no-cache'
  config.headers['Pragma'] = 'no-cache'

  return config
})

export default apiInstance
